import { Formik } from "formik";
import React, { useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as auth from "../_redux/authRedux";
import { useTranslation } from "react-i18next";

function RegistrationTaap(props) {
  const [step, setstep] = useState(0);
  const {t}= useTranslation();
  return (
    <div className="login login-3 login-signin-on d-flex flex-row-fluid" style={{ display: "block" }}>
      <div className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" style={{ backgroundImage: 'url(/media/bg/bg-3.jpg)' }}>
        <div className="col-xl-8 col-lg-10 col-md-12 col-12  p-7 position-relative overflow-hidden">
          <div className="d-flex flex-center mb-15">
            <a href={() => false}>
              <SVG src={toAbsoluteUrl("/media/svg/logos/TaapLogo.svg")} />
            </a>
          </div>
          <div className="card card-custom">
            <div className="card-body p-0">
              {/*begin::Wizard*/}
              <div className="Taap-color wizard wizard-1" id="kt_wizard" data-wizard-state="first" data-wizard-clickable="false">
                {/*begin::Wizard Nav*/}
                <div className="wizard-nav border-bottom">
                  <div className="wizard-steps p-8 p-lg-10">
                    <div className="wizard-step" data-wizard-type="step" data-wizard-state={`${step >= 0 ? "current" : "pending"}`}>
                      <div className="wizard-label">
                        <h3 className="wizard-title">{t('Plan_Details')}</h3>
                      </div>
                      <span className="svg-icon svg-icon-xl wizard-arrow">
                        {/*begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Navigation/Arrow-right.svg*/}
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                          <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                            <polygon points="0 0 24 0 24 24 0 24" />
                            <rect fill="currentcolor" opacity="0.3" transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)" x={11} y={5} width={2} height={14} rx={1} />
                            <path d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z" fill="currentcolor" fillRule="nonzero" transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)" />
                          </g>
                        </svg>
                        {/*end::Svg Icon*/}
                      </span>
                    </div>
                    {/*end::Wizard Step 3 Nav*/}
                    {/*begin::Wizard Step 4 Nav*/}
                    <div className="wizard-step" data-wizard-type="step" data-wizard-state={`${step > 0 ? "current" : "pending"}`}>
                      <div className="wizard-label">
                        <h3 className="wizard-title">{t('Billing_Details')}</h3>
                      </div>
                    </div>
                    {/*end::Wizard Step 4 Nav*/}
                  </div>
                </div>
                {/*end::Wizard Nav*/}
                {/*begin::Wizard Body*/}
                <div className="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
                  <div className="col-xl-12 col-xxl-7">
                    {/*begin::Wizard Form*/}
                    <Formik
                      initialValues={{
                        Email: "",
                        password: "",
                        firstName: "",
                        lastName: "",
                        Phone: "",
                        companyName: "",
                        companyEmail: "",
                        companyStreet: "",
                        companyCity: "",
                        companyState: "",
                        companyZip: "",
                        cardName: "",
                        cardNumber: "",
                        ExpirationDate1: "",
                        ExpirationDate2: "",
                        CVV: ""
                      }}
                      onSubmit={(values) => {

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/json");

                        var raw = JSON.stringify({
                          // "Email": Email,
                          // "FirstName": firstName,
                          // "LastName": lastName,
                          // "Password": password,
                          // "ConfirmPassword": password,
                          // "Phone": Phone,
                          // "companyName": companyName,
                          // "companyEmail": companyEmail,
                          // "companyStreet": companyStreet,
                          // "companyCity": companyCity,
                          // "companyState": companyState,
                          // "companyZip": companyZip,
                          // "cardName": cardName,
                          // "cardNumber": cardNumber,
                          // "ExpirationDate1": ExpirationDate1,
                          // "ExpirationDate2": ExpirationDate2,
                          // "CVV": CVV
                        });

                        var requestOptions = {
                          method: 'POST',
                          headers: myHeaders,
                          body: raw,
                          redirect: 'follow'
                        };


                        fetch("https://api-dev.kayro.io/api/account/register", requestOptions)
                          .then(response => response.text())
                          .then(async (response) => {
                            const res = await response;
                            if (res.status === 200) {
                              console.log("res.body");
                            }
                            return false;
                          })
                          .then((res) => {
                            if (res?.Code === "400") {
                              return false;
                            }

                          });
                      }}
                    >
                      {({
                        values,
                        status,
                        errors,
                        touched,
                        setFieldValue,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                        <form className="form fv-plugins-bootstrap fv-plugins-framework">

                          {step === 0 &&

                            <div className="pb-5">
                              <h4 className="mb-10 font-weight-bolder text-dark">{t('Choose_Plan')}</h4>
                              <div className="pb-10">
                                <Row>
                                  <Col xl="6" lg="6" md="12">
                                    <input type="radio" className="btn-check" name="auth_option" defaultValue="apps" defaultChecked="checked" id="kt_modal_two_factor_authentication_option_1" />
                                    <label className="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-5" htmlFor="kt_modal_two_factor_authentication_option_1">
                                      <span className="d-block font-weightbold text-left">
                                        <span className="text-dark font-weight-bolder d-block font-size-h3">{t('Monthly')}</span>
                                        <span className="text-muted font-weightbold d-block font-size-h6">$ 25</span>
                                        <span className="text-muted font-weightbold font-size-h6">$ 5/{t('Load')}</span>
                                      </span>
                                    </label>
                                  </Col>
                                  <Col xl="6" lg="6" md="12">
                                    <input type="radio" className="btn-check" name="auth_option" defaultValue="sms" id="kt_modal_two_factor_authentication_option_2" />
                                    <label className="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" htmlFor="kt_modal_two_factor_authentication_option_2">
                                      <span className="d-block font-weightbold text-left">
                                        <span className="text-dark font-weight-bolder d-block font-size-h3">{t('Annual')}</span>
                                        <span className="text-muted font-weightbold d-block font-size-h6">$ 300</span>
                                        <span className="text-muted font-weightbold font-size-h6">$ 5/{t('Load')}</span>
                                      </span>
                                    </label>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          }
                          {step === 1 &&

                            <div className="pb-5">
                              <h4 className="mb-10 font-weight-bold text-dark">{t('Setup_credit_debit_card')}</h4>
                              {/*begin::Input*/}
                              <div className="form-group fv-plugins-icon-container">
                                <label>{t("Name_On_Card ")}<span className="text-danger">*</span>
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip
                                        style={{ pointerEvents: "none" }}
                                        id="products-delete-tooltip"
                                      >
                                        {t('cardholder_s_name')}
                                      </Tooltip>
                                    }
                                  >
                                    <i className="fa fa-exclamation-circle ml-2 fs-7"></i>
                                  </OverlayTrigger>
                                </label>
                                <input type="text" className="form-control form-control-solid form-control-lg" onChange={(e) => {
                                  setFieldValue("cardName", e.target.value);
                                }} name="cardName" />
                                <div className="fv-plugins-message-container" /></div>
                              {/*end::Input*/}
                              {/*begin::Input*/}
                              <div className="form-group">
                                <label>{t('Card_Number')}  <span className="text-danger">*</span></label>
                                <div className="position-relative">
                                  <input type="text" className="form-control form-control-solid form-control-lg" onChange={(e) => {
                                    setFieldValue("cardNumber", e.target.value);
                                  }} name="CardNumber" />
                                  <div className="position-absolute translate-middle-c top-50 end-0 mr-5">
                                    <img src={toAbsoluteUrl("/media/svg/card-logos/visa.svg")} alt="" className="h-25px" />
                                    <img src={toAbsoluteUrl("/media/svg/card-logos/mastercard.svg")} alt="" className="h-25px" />
                                    <img src={toAbsoluteUrl("/media/svg/card-logos/american-express.svg")} alt="" className="h-25px" />
                                  </div>
                                </div>

                              </div>
                              {/*end::Input*/}
                              <div className="row">
                                <div className="col-xl-4">
                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <label>{t('Expiration_Date')}  <span className="text-danger">*</span></label>
                                    <select className="form-control form-control-solid form-control-lg" id="exampleSelect1">
                                      <option data-select2-id="exampleSelect1" />
                                      <option value={1}>1</option>
                                      <option value={2} >2</option>
                                      <option value={3} >3</option>
                                      <option value={4}>4</option>
                                      <option value={5} >5</option>
                                      <option value={6} >6</option>
                                      <option value={7} >7</option>
                                      <option value={8} >8</option>
                                      <option value={9} >9</option>
                                      <option value={10} >10</option>
                                      <option value={11} >11</option>
                                      <option value={12} >12</option>
                                    </select>
                                    <div className="fv-plugins-message-container" /></div>
                                  {/*end::Input*/}
                                </div>

                                <div className="col-xl-4">
                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container mt-8">

                                    <select className="form-control form-control-solid form-control-lg" id="exampleSelect2">
                                      <option data-select2-id="exampleSelect2" />
                                      <option value={1}>2022</option>
                                      <option value={2} >2023</option>
                                      <option value={3} >2024</option>
                                      <option value={4}>2025</option>
                                      <option value={5} >2026</option>
                                      <option value={6} >2027</option>
                                      <option value={7} >2028</option>
                                      <option value={8} >2029</option>
                                      <option value={9} >2029</option>
                                      <option value={10} >2030</option>
                                      <option value={11} >2031</option>
                                      <option value={12} >2032</option>
                                    </select>
                                    <div className="fv-plugins-message-container" /></div>
                                  {/*end::Input*/}
                                </div>

                                <div className="col-xl-4">
                                  {/*begin::Input*/}
                                  <div className="form-group fv-plugins-icon-container">
                                    <label>CVV <span className="text-danger">*</span>
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip
                                            style={{ pointerEvents: "none" }}
                                            id="products-delete-tooltip"
                                          >
                                            {t('Enter_CVV_code')}
                                          </Tooltip>
                                        }
                                      >
                                        <i className="fa fa-exclamation-circle ml-2 fs-7"></i>
                                      </OverlayTrigger>
                                    </label>
                                    <div className="position-relative">
                                      <input type="text"
                                        maxlength="4"
                                        className="form-control form-control-solid form-control-lg" onChange={(e) => {
                                          if (!Number(e.target.value) && e.target.value !== "") {
                                            return;
                                          }
                                          setFieldValue("CVV", e.target.value);
                                        }} name="CVV" />
                                      <div className="position-absolute translate-middle-c top-50 end-0 mr-3">
                                        <span className="svg-icon svg-icon-2hx">
                                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                                            <path d="M22 7H2V11H22V7Z" fill="currentColor" />
                                            <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19ZM14 14C14 13.4 13.6 13 13 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H13C13.6 15 14 14.6 14 14ZM16 15.5C16 16.3 16.7 17 17.5 17H18.5C19.3 17 20 16.3 20 15.5C20 14.7 19.3 14 18.5 14H17.5C16.7 14 16 14.7 16 15.5Z" fill="currentColor" />
                                          </svg>
                                        </span>
                                      </div>
                                    </div>

                                    <div className="fv-plugins-message-container" /></div>
                                  {/*end::Input*/}
                                </div>
                              </div>

                            </div>
                          }
                          <div className="d-flex justify-content-between border-top mt-5 pt-10">
                            {step !== 0 &&
                              <div className="mr-2">


                                <button type="button" onClick={() => {
                                  setstep(step - 1)
                                }} className="btn btn-secondary font-weight-bolder text-uppercase px-9 py-4">Back</button>
                              </div>
                            }
                            <div className="ml-auto">
                              {step === 1 &&

                                <button type="button" onClick={handleSubmit} className="btn btn-success font-weight-bolder text-uppercase px-9 py-4">Submit</button>}
                              {step !== 1 &&

                                <button type="button" onClick={() => {
                                  setstep(step + 1)
                                }} className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4">Next</button>}
                            </div>
                          </div>
                          {/*end::Wizard Actions*/}
                          <div /><div /><div /><div /></form>
                      )}
                    </Formik>


                    {/*end::Wizard Form*/}
                  </div>
                </div>
                {/*end::Wizard Body*/}
              </div>
              {/*end::Wizard*/}
            </div>
            {/*end::Wizard*/}
          </div>
        </div>
      </div >
    </div >
  );
}

export default injectIntl(connect(null, auth.actions)(RegistrationTaap));
